import React, { useState } from "react";
import Input from "../components/input/Input";
import { userlogin } from "../Services/ApiService";
import Public from "../Routes/Public";
import CryptoJS from "crypto-js";
import { toast } from "react-toastify";
import Private from "../Routes/Private";
import { useNavigate } from "react-router-dom";

const SuperAdminLogin = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const secretKey = "KampusNcrt";
  const navigate = useNavigate();

  const checkuseridfun = async () => {
    let body;
    body = {
      userId: username,
      password: password,
      role: "SuperAdmin",
    };
    try {
      let res = await userlogin(body);

      if (res?.success === true) {
        <Public isLogged={true} />;

        const encryptedMedium = CryptoJS.AES.encrypt(
          JSON.stringify(res.value.medium),
          secretKey
        ).toString();
        const encryptedSubjects = CryptoJS.AES.encrypt(
          JSON.stringify(res.value.subjects),
          secretKey
        ).toString();
        const encryptedStandard = CryptoJS.AES.encrypt(
          JSON.stringify(res.value.standard),
          secretKey
        ).toString();
        const encryptedCode = CryptoJS.AES.encrypt(
          JSON.stringify(res.value.code),
          secretKey
        ).toString();
        const encryptedUserID = CryptoJS.AES.encrypt(
          JSON.stringify(res.value.userId),
          secretKey
        ).toString();
        const { firstName, lastName } = res.value;
        const username = `${firstName} ${lastName}`;
        //   const userCode = res.value.code;
        //   const userId = res.value.userId;
        localStorage.setItem("userID", encryptedUserID);
        localStorage.setItem("userCode", encryptedCode);
        localStorage.setItem("username", username);
        localStorage.setItem("encryptedMedium", encryptedMedium);
        localStorage.setItem("encryptedSubjects", encryptedSubjects);
        localStorage.setItem("encryptedStandard", encryptedStandard);
        localStorage.setItem("token", res?.token);
        localStorage.setItem("IsUserAuth", true);
        localStorage.setItem("userData", JSON.stringify(res?.value));
        localStorage.setItem("userType", JSON.stringify(res?.value.userTypeId));
        // sessionStorage.setItem('token', res?.token);
        sessionStorage.setItem("user", JSON.stringify(res?.value));

        toast.success(res?.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
        <Private isLogged={true} />;
        //  window.location.href = "/bookview";
        navigate("/dashboard");
      } else {
        // console.log(res.error, res, "testtstst")
        toast.error(res?.error, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div
      style={{ height: "100vh" }}
      className="d-flex flex-column align-items-center justify-content-center"
    >
      <div className="shadow bg-white rounded py-3" style={{ width: "30%" }}>
        <div className="katbooktext d-flex justify-content-center pb-3">
          Admin Login
        </div>

        <div className="container">
          <div className="d-flex flex-column justify-content-center align-items-center gap-2">
            <div className="col-md-10 mb-3">
              <Input
                label={"User Id / Mobile No"}
                placeholder={"Enter User Id / Mobile No"}
                labelClassName={"Select_label"}
                className={"input-size p-2"}
                value={username}
                onChange={(e) => {
                  setUsername(e.target.value);
                  // setselecteduserId("");
                  // setUserValidate(false);
                  // setUserValidateList({});
                  // setLoginState({ ...LoginState, user: e.target.value });
                  // console.log(e.target.value, "yyyyyyyyyyy");
                  // console.log(e.target.value.length, "yyyyyyyyyyy");
                  // if (isNumber(e.target.value)) {
                  //     if (e.target.value.length === 10) {
                  //         uservalidateFunc(e.target.value);
                  //     }
                  // }
                }}
              />
            </div>

            <div className="col-md-10 mb-3">
              <Input
                label={"Password"}
                placeholder={"Enter Password"}
                labelClassName={"Select_label"}
                className={"input-size p-2"}
                isDisabled={!username}
                isPassword
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                }}
              />
            </div>

            <div
              className="col-md-10 text-end"
              // onClick={() => {
              //     if (LoginState.user === "") {
              //         toast.error("Please enter User Id / Mobile No");
              //     } else if (UserValidate && selecteduserId == "") {
              //         toast.error("Please select any one user Id");
              //     } else {
              //         generateOTPfunc("reset", "", roleName);
              //         setSecondsPassed(0);
              //         setTimerActive(true);
              //         setisResend(true);
              //     }
              // }}
            >
              <span className="cursor forgetpwdfont">Forgot Password ? </span>
            </div>

            <div className="">
              <button
                className="btn btn-success buttonLogin-admin w-100 mt-3"
                disabled={!password}
                // onClick={() => {
                //     if (UserValidate && selecteduserId == "") {
                //         toast.error("Please select any one user Id");
                //     } else {
                //         loginuserfunc();
                //     }
                // }}
                onClick={checkuseridfun}
              >
                Login
              </button>
            </div>
          </div>

          {/* <div className="col-md-4 d-flex justify-content-end forgetpwdfont">
                    <div className="cursor"
                    // onClick={() => {
                    //     if (LoginState.user === "") {
                    //         toast.error("Please enter User Id / Mobile No");
                    //     } else if (UserValidate && selecteduserId == "") {
                    //         toast.error("Please select any one user Id");
                    //     } else {
                    //         generateOTPfunc("reset", "", roleName);
                    //         setSecondsPassed(0);
                    //         setTimerActive(true);
                    //         setisResend(true);
                    //     }
                    // }}
                    >
                        Forgot Password ?
                    </div>
                </div> */}

          {/* <div className="mb-3">
                    <button
                        className="btn btn-success buttonLogin w-100 mt-3"
                    // disabled={!isFormValidLogin()}
                    // onClick={() => {
                    //     if (UserValidate && selecteduserId == "") {
                    //         toast.error("Please select any one user Id");
                    //     } else {
                    //         loginuserfunc();
                    //     }
                    // }}
                    >
                        Login
                    </button>
                </div> */}

          {/* {UserValidate &&
                            UserValidateList.otherUser.map((x, i) => (
                                <span
                                    className={"Stu_userData gap-1 cursor"}
                                    style={{
                                        background:
                                            selecteduserId === x.userId ? "#004857" : "",
                                        color: selecteduserId === x.userId ? "#ffffff" : "",
                                    }}
                                    onClick={() => {
                                        setselecteduserId(x.userId);
                                    }}
                                >
                                    {x.studentId.slice(1)}
                                </span>
                            ))} */}

          {/* <div className="col-md-3 mb-3">
                    <Input
                        label={"Password"}
                        placeholder={"Enter Password"}
                        labelClassName={"Select_label"}
                        className={"input-size p-2"}
                        isPassword
                        // value={LoginState.pwd}
                        onChange={(e) => {
                            // setLoginState({ ...LoginState, pwd: e.target.value });
                        }}
                    />
                </div> */}

          {/* <div className="d-flex justify-content-end forgetpwdfont">
                        <span
                            className="cursor"
                        // onClick={() => {
                        //     if (LoginState.user === "") {
                        //         toast.error("Please enter User Id / Mobile No");
                        //     } else if (UserValidate && selecteduserId == "") {
                        //         toast.error("Please select any one user Id");
                        //     } else {
                        //         generateOTPfunc("reset", "", roleName);
                        //         setSecondsPassed(0);
                        //         setTimerActive(true);
                        //         setisResend(true);
                        //     }
                        // }}
                        >
                            Forgot Password ?
                        </span>
                    </div> */}

          {/* <div className="mb-3">
                        <button
                            className="btn btn-success buttonLogin w-100 mt-3"
                        // disabled={!isFormValidLogin()}
                        // onClick={() => {
                        //     if (UserValidate && selecteduserId == "") {
                        //         toast.error("Please select any one user Id");
                        //     } else {
                        //         loginuserfunc();
                        //     }
                        // }}
                        >
                            Login
                        </button>
                    </div> */}
        </div>
      </div>
    </div>
  );
};

export default SuperAdminLogin;
